import { client as defaultClient } from '@api/client';
import type { Client } from '@api/functions';

export async function getConfig(client?: Client) {
    return (client || defaultClient).GET('/app/config', {});
}